import { ReportableItem } from "../../@types/Posts";
import { api } from "../api";

export default async function storeReporting(
  data: ReportableItem[]
): Promise<boolean> {
  try {
    const { status } = await api.post("/posts", { posts: data });

    return status === 200;
  } catch (err) {
    console.log(err);

    return false;
  }
}
